import { RouteObject, Outlet, Navigate } from 'react-router-dom';
import type { RouterProps } from 'contracts/Router';
import {
  DriverCreationPage,
  DriversListPage,
  DriverUpdatePage,
} from 'pages/Drivers';

const driversRoutes = ({
  location,
  userBelongsToAnyOf,
}: RouterProps): RouteObject => ({
  path: 'configuracoes/motoristas',
  element: userBelongsToAnyOf('admin') ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} />
  ),
  children: [
    {
      path: '',
      element: <DriversListPage />,
    },
    {
      path: 'criar',
      element: <DriverCreationPage />,
    },
    {
      path: ':id/editar',
      element: <DriverUpdatePage />,
    },
  ],
});

export default driversRoutes;
